<template>
	<div class="side_menu">
		<div class="scroller">
			<el-menu :default-active="activeIndex" @select="handleSelect">
				<!-- app -->
				<el-submenu index="1">
					<template slot="title">
						<span>科飞云App</span>
					</template>

					<!-- 商户管理 -->
					<el-submenu index="1-1" style="margin-top: 5px">
						<template slot="title">
							<span>商户管理</span>
						</template>
						<el-menu-item index="1-1-1">商户管理</el-menu-item>
					</el-submenu>
					<!-- 商户管理 end -->

					<!-- 店铺管理 -->
					<el-submenu index="1-2">
						<template slot="title">
							<span>店铺管理</span>
						</template>
						<el-menu-item index="1-2-1">商品管理</el-menu-item>
						<el-menu-item index="1-2-2">订单管理</el-menu-item>
						<el-menu-item index="1-2-3">疾病分类</el-menu-item>
					</el-submenu>
					<!-- 店铺管理 end -->

					<!-- 文章管理 -->
					<el-submenu index="1-3">
						<template slot="title">
							<span>文章管理</span>
						</template>
						<el-menu-item index="1-3-1">文章信息</el-menu-item>
						<el-menu-item index="1-3-2">文章分类</el-menu-item>
						<el-menu-item index="1-3-3">常见问题</el-menu-item>
					</el-submenu>
					<!-- 文章管理 end -->

					<!-- 轮播管理 -->
					<el-submenu index="1-4">
						<template slot="title">
							<span>轮播管理</span>
						</template>
						<el-menu-item index="1-4-1">首页轮播</el-menu-item>
					</el-submenu>
					<!-- 轮播管理 end -->

					<!-- 信息管理 -->
					<el-submenu index="1-5">
						<template slot="title">
							<span>信息管理</span>
						</template>
						<el-menu-item index="1-5-1">热门搜索</el-menu-item>
					</el-submenu>
					<!-- 信息管理 end -->
				</el-submenu>
				<!-- app end -->

				<!-- i练助手 -->
				<el-submenu index="2">
					<template slot="title">
						<span>i练助手</span>
					</template>
					<el-menu-item index="2-1">banner管理</el-menu-item>
					<el-menu-item index="2-2">卡片管理</el-menu-item>
					<el-menu-item index="2-3">分类管理</el-menu-item>
					<el-menu-item index="2-4">成功案例管理</el-menu-item>
					<el-menu-item index="2-5">科普社区管理</el-menu-item>
					<el-menu-item index="2-6">网课视频管理</el-menu-item>
					<el-menu-item index="2-7">科普知识管理</el-menu-item>
					<el-submenu index="2-8">
						<template slot="title">
							<span>积分系统</span>
						</template>
						<el-menu-item index="2-8-1">兑换管理</el-menu-item>
						<el-menu-item index="2-8-2">积分记录</el-menu-item>
					</el-submenu>
				</el-submenu>
				<!-- i练助手 end -->

				<!-- mall -->
				<el-submenu index="3">
					<template slot="title">
						<span>科飞商城</span>
					</template>
					<!-- 店铺管理 -->
					<el-submenu index="3-1" style="margin-top: 5px">
						<template slot="title">
							<span>店铺管理</span>
						</template>
						<el-menu-item index="3-1-1">商品管理</el-menu-item>
						<el-menu-item index="3-1-2">订单管理</el-menu-item>
						<el-menu-item index="3-1-3">疾病分类</el-menu-item>
					</el-submenu>
					<!-- 店铺管理 end -->
				</el-submenu>
				<!-- mall end -->
				<!-- 隐美视 -->
				<el-submenu index="4">
					<template slot="title">
						<span>隐美视</span>
					</template>
					<el-menu-item index="4-1">滤波镜片</el-menu-item>
				</el-submenu>
			</el-menu>
		</div>

		<div class="ft">
			版权所有@
			<a href="http://www.uflyvision.com/" target="_blank">科飞视觉</a>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';

const PATH_LIST = [
	{
		index: '1-1-1',
		path: '/index/application/app/merchant_merchant'
	},
	{
		index: '1-2-1',
		path: '/index/application/app/shop_goods'
	},
	{
		index: '1-2-2',
		path: '/index/application/app/shop_orders'
	},
	{
		index: '1-2-3',
		path: '/index/application/app/shop_disease'
	},
	{
		index: '1-3-1',
		path: '/index/application/app/articles'
	},
	{
		index: '1-3-2',
		path: '/index/application/app/article_types'
	},
	{
		index: '1-3-3',
		path: '/index/application/app/article_problems'
	},
	{
		index: '1-4-1',
		path: '/index/application/app/swiper_home'
	},
	{
		index: '1-5-1',
		path: '/index/application/app/info_hot'
	},
	{
		index: '2-1',
		path: '/index/application/i_assistant/banner'
	},
	{
		index: '2-2',
		path: '/index/application/i_assistant/card'
	},
	{
		index: '2-3',
		path: '/index/application/i_assistant/sort'
	},
	{
		index: '2-4',
		path: '/index/application/i_assistant/case'
	},
	{
		index: '2-5',
		path: '/index/application/i_assistant/community'
	},
	{
		index: '2-6',
		path: '/index/application/i_assistant/course'
	},
	{
		index: '2-7',
		path: '/index/application/i_assistant/knowledge'
	},
	{
		index: '2-8-1',
		path: '/index/application/i_assistant/integral_exchange'
	},
	{
		index: '2-8-2',
		path: '/index/application/i_assistant/integral_records'
	},
	{
		index: '3-1-1',
		path: '/index/application/mall/shop_goods'
	},
	{
		index: '3-1-2',
		path: '/index/application/mall/shop_order'
	},
	{
		index: '3-1-3',
		path: '/index/application/mall/shop_disease'
	},
	{
		index: '4-1',
		path: '/index/application/lens_order'
	}
];
export default {
	data() {
		return {
			activeIndex: ''
		};
	},
	computed: {
		...mapState(['authInfo'])
	},
	created() {
		this.initActiveIndex();
	},
	methods: {
		initActiveIndex() {
			const that = this;
			let path = this.$route.path;
			PATH_LIST.forEach((v) => {
				v.path == path && (that.activeIndex = v.index);
			});
		},
		handleSelect(key) {
			var _path,
				_currentPath = this.$route.path;
			PATH_LIST.forEach((v) => {
				v.index == key && (_path = v.path);
			});
			_currentPath != _path && this.$router.push({ path: _path });
		}
	},
	watch: {
		$route() {
			this.initActiveIndex();
		}
	}
};
</script>

<style>
.app_manage_page .side_menu {
	display: block;
	position: absolute;
	z-index: 99;
	width: 220px;
	height: 100%;
	top: 0;
	left: 0;
	padding-bottom: 48px;
	background: #fff;
}
.app_manage_page .side_menu:after {
	content: '';
	display: block;
	position: absolute;
	width: 1px;
	height: 100%;
	top: 0;
	right: 0;
	background: #ccc;
}
.app_manage_page .side_menu .scroller {
	display: block;
	width: 100%;
	height: 100%;
	overflow-y: auto;
}
.app_manage_page .side_menu .scroller::-webkit-scrollbar {
	display: none;
}
.app_manage_page .side_menu .ft {
	position: absolute;
	width: 100%;
	height: 48px;
	bottom: 0px;
	padding: 10px 15px;
	font-size: 12px;
	text-align: center;
	line-height: 28px;
}
.app_manage_page .side_menu .ft:before {
	content: '';
	display: block;
	position: absolute;
	width: 100%;
	height: 1px;
	top: 0;
	left: 0;
	background: #ccc;
}
.app_manage_page .side_menu .ft a {
	color: #30a5ff;
}
.app_manage_page .side_menu .ft a:hover {
	text-decoration: underline;
}

.app_manage_page .side_menu .el-menu {
	border-right: none;
}
.app_manage_page .side_menu .el-submenu {
	margin-top: 5px;
}
.app_manage_page .side_menu .el-submenu:first-child {
	margin-top: 0;
}
.app_manage_page .side_menu .el-submenu__title {
	height: 40px;
	background-color: #30a5ff;
	color: #fff;
	line-height: 40px;
}
.app_manage_page .side_menu .el-submenu__icon-arrow {
	font-size: 18px;
	color: #fff;
}
.app_manage_page .side_menu .el-menu-item {
	height: 40px;
	color: #30a5ff;
	line-height: 40px;
}
.app_manage_page .side_menu .el-menu-item.is-active {
	background: #ecf5ff;
}
</style>
